import { useState, useEffect } from "react";
import Icon from "./Icon";

export default function CookieConsentBanner({ onOpenPolicy }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsentAccepted");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsentAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-40 bg-surface-card border border-outline-variant/60 rounded-3xl p-5 shadow-2xl backdrop-blur-md animate-slide-up flex flex-col gap-3">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-2xl bg-amber-500/10 text-amber-600 flex items-center justify-center flex-shrink-0">
          <Icon name="cookie" className="!text-[22px]" filled />
        </div>
        <div className="flex-1">
          <h4 className="text-sm font-bold text-on-surface">Çerez Politikası ve Deneyim</h4>
          <p className="text-xs text-on-surface-variant leading-relaxed mt-0.5">
            Sistemimiz; güvenli giriş, oturum yönetimi ve en iyi deneyimi sunmak amacıyla zorunlu çerezler kullanmaktadır.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-end gap-2 pt-1">
        <button
          onClick={onOpenPolicy}
          className="text-xs font-semibold text-primary hover:underline px-3 py-1.5 rounded-lg transition"
        >
          Detayları İncele
        </button>
        <button
          onClick={handleAccept}
          className="bg-primary hover:bg-primary-hover text-white text-xs font-bold px-4 py-2 rounded-xl transition shadow-sm flex items-center gap-1.5 cursor-pointer"
        >
          <Icon name="check" className="!text-[16px]" />
          Kabul Et
        </button>
      </div>
    </div>
  );
}
